import { useLocalStorage } from 'usehooks-ts';

export type IUseDensityResult = [number, (density: number) => void];

export const useDensity = (): IUseDensityResult => {
  const [density, setDensity] = useLocalStorage<number>(
    '@@crowdaa@@::density',
    0,
    {
      initializeWithValue: true,
      serializer: String,
      deserializer: Number,
    },
  );

  return [density, setDensity];
};
